namespace Solovis.Reports {

    /*
     * ReportBuilder has helper methods for putting together report definitions.
     */
    export class ReportBuilder {

        public _reportParameters;

        constructor(options) {
            this._reportParameters = options.reportParameters ? options.reportParameters : null;
        }


        public createReportBlockWithHeader(subReportBlock, moreOptions) {
            var blockWithHeader: any = {
                layout: "BlockWithHeader",

                style: {
                    width: "100%"
                },

                header: {
                    partControl: "Solovis.Reports.Parts.SubReportBlockHeaderControl",
                    settings: {
                        subReportElementName: subReportBlock.elementName
                    }
                },

                content: subReportBlock,

                noPaddingOnContent: true
            };

            if (moreOptions) {
                if (moreOptions.customTitle) {
                    blockWithHeader.header.settings.customTitle = moreOptions.customTitle;
                }
            }

            return blockWithHeader;
        }


        public createBlockWithHeader(block, moreOptions) {
            var blockWithHeader = {
                layout: "BlockWithHeader",

                style: {
                    width: "100%"
                },

                header: {
                    headerText: moreOptions.customTitle
                },

                content: block,

                noPaddingOnContent: true
            };

            return blockWithHeader;
        }


        public createTab(tabOptions) {
            var self = this;

            var tabCode = tabOptions.tabCode;
            var tabLabel = tabOptions.tabLabel;
            var root = tabOptions.root;

            var dataSources = tabOptions.dataSources;

            var tabBlock = {
                code: tabCode,
                label: tabLabel,

                noPadding: true,
                keepTabBetweenRunsIfActive: false,
                usePersistedSettings: true,

                // clear because graphs will not redraw properly while report is hidden
                clearOnTabDeactivate: true,

                reportOptions: function () {
                    var options: any = {
                        report: {
                            parameters: self._reportParameters
                        },

                        parameters: this.parameters,

                        showConfigSectionInline: false,
                        autoRun: true,
                        hideReportOptionsButton: true
                    };

                    if (typeof root == "object") {
                        options.report.root = root;
                    }
                    else if (typeof root == "function") {
                        options.report.root = root.call(this);
                    }

                    if (typeof dataSources == "object") {
                        options.report.dataSources = dataSources;
                    }
                    else if (typeof dataSources == "function") {
                        options.report.dataSources = dataSources.call(this);
                    }

                    if (tabOptions.subReportParameterSyncs) {
                        options.report.subReportParameterSyncs = tabOptions.subReportParameterSyncs;
                    }

                    return options;
                }
            };

            return tabBlock;
        }


        public createTabStrip = function (tabStripOptions) {
            var elementName = tabStripOptions.elementName;

            var tabStripBlock: any = {
                elementName: elementName,
                partControl: 'Solovis.Reports.Parts.TabListSubReportControl',

                settings: {
                    tabs: function () {
                        var newTabs;
                        if (typeof tabStripOptions.tabs == "object") {
                            newTabs = tabStripOptions.tabs;
                        }
                        else if (typeof tabStripOptions.tabs == "function") {
                            newTabs = tabStripOptions.tabs.call(this);
                        }

                        var tabList = [];

                        $(newTabs).each(function (i, tab) {
                            tabList.push(tab);
                        });

                        return tabList;
                    }
                }
            };

            if (tabStripOptions.dataSources) {
                tabStripBlock.dataSources = tabStripOptions.dataSources;
            }

            return tabStripBlock;
        }
    }

}


    